import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
const activities = [{
  initials: 'MG',
  name: 'Martina G.',
  loc: 'Buenos Aires',
  action: 'cobró',
  amount: 'USD 80',
  time: 'hace 3 min'
}, {
  initials: 'LP',
  name: 'Lucas P.',
  loc: 'Córdoba',
  action: 'cerró un cliente por',
  amount: 'USD 350',
  time: 'hace 7 min'
}, {
  initials: 'RM',
  name: 'Romina M.',
  loc: 'Rosario',
  action: 'firmó un retainer mensual de',
  amount: 'USD 450',
  time: 'hace 12 min'
}, {
  initials: 'VA',
  name: 'Valentina A.',
  loc: 'Tucumán',
  action: 'entregó un proyecto por',
  amount: 'USD 120',
  time: 'hace 18 min'
}, {
  initials: 'NL',
  name: 'Nicolás L.',
  loc: 'Rosario',
  action: 'cobró',
  amount: 'USD 200',
  time: 'hace 22 min'
}, {
  initials: 'DM',
  name: 'Daniela M.',
  loc: 'Córdoba',
  action: 'recibió su primer pago de',
  amount: 'USD 60',
  time: 'hace 31 min'
}, {
  initials: 'SC',
  name: 'Santiago C.',
  loc: 'Buenos Aires',
  action: 'escaló a',
  amount: 'USD 1.000/mes',
  time: 'hace 44 min'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  loc: 'Neuquén',
  action: 'cerró 3 clientes esta semana',
  amount: '',
  time: 'hace 1 h'
}];
export function LiveActivityTicker() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % activities.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-petroleum border-y border-electric/10 h-11 flex items-center justify-center overflow-hidden relative z-20" data-id="element-411">
      <AnimatePresence mode="wait" data-id="element-412">
        <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.3
      }} className="flex items-center gap-3 text-xs md:text-sm px-4 w-full max-w-3xl justify-center" aria-live="polite" data-id="element-413">
          <div className="w-2 h-2 rounded-full bg-energy relative flex-shrink-0 shadow-[0_0_8px_rgba(0,230,118,0.7)]" data-id="element-414"></div>

          <div className="hidden sm:flex w-6 h-6 rounded-full bg-gradient-to-br from-electric to-golddark items-center justify-center text-graphite font-bold text-[10px] flex-shrink-0" data-id="element-415">
            {activities[currentIndex].initials}
          </div>

          <div className="text-textsecondary truncate" data-id="element-416">
            <span className="text-white font-semibold" data-id="element-417">
              {activities[currentIndex].name}
            </span>
            <span className="hidden sm:inline" data-id="element-418">
              {' '}
              · {activities[currentIndex].loc}
            </span>{' '}
            {activities[currentIndex].action}{' '}
            {activities[currentIndex].amount && <span className="text-energy font-bold" data-id="element-419">
                {activities[currentIndex].amount}
              </span>}
            <span className="text-textsecondary/60" data-id="element-420">
              {' '}
              · {activities[currentIndex].time}
            </span>
          </div>

          <TrendingUp className="w-4 h-4 text-energy flex-shrink-0 hidden sm:block" data-id="element-421" />
        </motion.div>
      </AnimatePresence>
    </div>;
}